import React from 'react';
import type {DataLoadStatus} from 'api/types';
import type {Note} from 'services/data/notes/types';
import type {Media} from 'services/media/types';
import type {WorkV4} from 'services/metadata/types';
import type {ManifestationPanel as ManifestationPanelType} from '../types';
import {FilesPanel} from '../../FilesPanel';
import {InfoPanel} from '../../InfoPanel';
import {NotesPanel} from '../../NotesPanel';

type Props = {
  manifestationId: string;
  showManifestationPanel?: ManifestationPanelType | undefined;
  onToggleManifestationPanel: (panel: ManifestationPanelType) => void;
  media: Media[];
  notes: DataLoadStatus<Note[]>;
  createNote: (note: string) => Promise<void>;
  updateNote: (id: string, note: string) => Promise<void>;
  removeNote: (id: string) => Promise<void>;
  workSuggestions?: Partial<WorkV4>;
  trykkunderlagReserved?: boolean;
};

export const ManifestationPanel: React.FC<Props> = ({
  manifestationId,
  showManifestationPanel,
  onToggleManifestationPanel,
  media,
  notes,
  createNote,
  updateNote,
  removeNote,
  workSuggestions,
  trykkunderlagReserved,
}) => {
  return (
    <>
      {showManifestationPanel === 'files' ? (
        <FilesPanel
          media={media}
          manifestationId={manifestationId}
          onClose={() => onToggleManifestationPanel('files')}
          trykkunderlagReserved={trykkunderlagReserved}
        />
      ) : showManifestationPanel === 'notes' ? (
        <NotesPanel
          notes={notes}
          onCreateNote={createNote}
          onUpdateNote={updateNote}
          onRemoveNote={removeNote}
          onClose={() => onToggleManifestationPanel('notes')}
        />
      ) : showManifestationPanel === 'info' ? (
        <InfoPanel
          manifestationId={manifestationId}
          workSuggestions={workSuggestions}
          onClose={() => onToggleManifestationPanel('info')}
        />
      ) : null}
    </>
  );
};
